import { useCallback, useState, useMemo } from 'react';
import { Form, Input, Button, DatePicker } from 'antd';
import moment from 'moment';

export default function ExpressForm(props) {
  const [initialValues, setInitialValues] = useState({ expressCompany: '顺丰快递', postedDate: moment() })
  const expressTypeLabel = useMemo(() => props.expressType === 'receive' ? '接收' : '邮寄', [props.expressType]);
  // 填写邮寄信息
  const onFinish = useCallback(async (values) => {
    const { postedDate, ...otherValues } = values;
    props.onSuccess && props.onSuccess({
      postedDate: postedDate.valueOf(),
      ...otherValues
    })
  }, [props])

  const onCancel = useCallback(() => props.onCancel && props.onCancel(), [props]);

  return <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onFinish={onFinish} initialValues={initialValues}>
    <Form.Item label={`${expressTypeLabel}时间`} name="postedDate" rules={[{ required: true, message: '请选择邮寄时间' }]}>
      <DatePicker showTime style={{ width: '100%' }} />
    </Form.Item>
    <Form.Item label="快递公司" name="expressCompany" rules={[{ required: true, message: '请输入快递公司' }]}>
      <Input placeholder="请输入" />
    </Form.Item>
    <Form.Item label="运单号" name="expressNumber" rules={[{ required: true, message: '请输入运单号' }]}>
      <Input placeholder="请输入" />
    </Form.Item>
    <Form.Item name="remark" label="备注">
      <Input.TextArea maxLength={500} placeholder="请输入描述说明, 500字内" style={{ height: 80 }} />
    </Form.Item>
    <Form.Item className="align-right" style={{ marginBottom: 0 }} wrapperCol={{ offset: 4, span: 20 }}>
      <Button className="margin-right" onClick={onCancel}>取消</Button>
      <Button type="primary" htmlType="submit" loading={props.loading}>确定</Button>
    </Form.Item>
  </Form>
}